export const LoanOfficerMainTabMessage = {
    SendSecureInvitation: "Send Secure Invitation Link",
    SendingSecureInvitation: "Sending Secure Invitation Link",
    SentSecureInvitation: "Sent Secure Invitation Link",
    ApplicationFeeNotCollected: "The Application fee has not been collected. The Borrower will need to pay their application fee."
}